import { createFileRoute } from '@tanstack/react-router'
import { Helmet } from 'react-helmet-async'
import { SalesReportPage } from '@/features/reports/sales/sales-report-page'
import { formatDocumentTitle } from '@/lib/document-title'

/**
 * Reports › Sales at `/$orgId/reports/sales`. Owner-only: the Reports layout refuses a typed URL from anyone who
 * may not see money (the nav item's rule), and the API answers them 403.
 */
export const Route = createFileRoute('/_auth/$orgId/reports/sales')({
  component: SalesRoute,
})

function SalesRoute() {
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Sales')}</title>
      </Helmet>
      <SalesReportPage />
    </>
  )
}
